<template>
  <div class="comboEdit">
    <el-dialog
      :title="`${title}活动`"
      :visible.sync="visible"
      class="comboEdit-dialog"
      width="900px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="80px"
          label-position="right"
          class="combo-edit-form">
          <el-form-item label="活动名称" prop="cseName">
            <el-input
              v-model="form.cseName"
              placeholder="请输入活动名称"
              class="combo-edit-field"
              clearable
              :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))">
            </el-input>
          </el-form-item>
          <el-form-item label="活动时间" required>
            <div class="combo-edit-date-form-wrap">
              <el-form-item prop="startTime" class="combo-edit-date-form-item">
                <el-date-picker
                  v-model="form.startTime"
                  type="datetime"
                  class="combo-edit-daterange"
                  default-time="00:00:00"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择开始时间"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                  :picker-options="startTimePickerOptions"
                  @change="handleStartTimeChange">
                </el-date-picker>
              </el-form-item>
              <div class="combo-edit-date-form-text">至</div>
              <el-form-item prop="endTime" class="combo-edit-date-form-item">
                <el-date-picker
                  v-model="form.endTime"
                  type="datetime"
                  class="combo-edit-daterange"
                  default-time="23:59:59"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择结束时间"
                  :disabled="(type === 'view') || (type === 'edit' && [2].includes(form.status))"
                  :picker-options="endTimePickerOptions"
                  @change="handleEndTimeChange">
                </el-date-picker>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="活动类型" prop="cseType">
            <el-radio-group
              class="combo-edit-radio-group"
              v-model="form.cseType"
              :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
              @change="onCseTypeChange">
              <el-radio :label="2">任选</el-radio>
              <el-radio :label="1">套餐</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动规则" required>
            <div v-if="form.cseType === 2" class="combo-edit-rule-row">
              <span class="combo-edit-rule-optional_text">任选</span>
              <el-form-item prop="drugCount" class="combo-edit-rule-form-item">
                <el-input
                  v-model="form.drugCount"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                  @input="handleDrugCountInput"
                  placeholder="">
                </el-input>
              </el-form-item>
              <span class="combo-edit-rule-optional_text">件，共</span>
              <el-form-item prop="price" class="combo-edit-rule-form-item">
                <el-input
                  v-model="form.price"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                  @input="handlePriceInput"
                  placeholder="">
                </el-input>
              </el-form-item>
              <span class="combo-edit-rule-optional_text">元</span>
            </div>
            <div v-if="form.cseType === 1" class="combo-edit-rule-row">
              <div class="combo-edit-rule-combo-count">
                <span class="combo-edit-rule-combo-count_text">套餐合计</span>
                <span class="combo-edit-rule-combo-count_num">{{ comboQuantityCount }}件</span>
                <span class="combo-edit-rule-combo-count_text">，金额合计</span>
                <span class="combo-edit-rule-combo-count_num">{{ comboTotalPriceCount }}元</span>
              </div>
              <div class="combo-edit-rule-combo-tips">
                <span class="el-icon-info combo-edit-rule-combo-tips_icon"></span>
                <span class="combo-edit-rule-combo-tips_text">选择活动商品后，系统将自动计算</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="combo-edit-checkbox-group" label="活动标签" prop="labels">
            <el-checkbox-group v-model="form.labels" :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))">
              <el-checkbox :label="2">理疗</el-checkbox>
              <el-checkbox :label="1">普通</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <div class="combo-edit-info">
          <el-radio-group v-model="activeSection" class="combo-edit-tabs">
            <el-radio-button v-for="tab in sectionTabs" :label="tab.value">{{ tab.label }}</el-radio-button>
          </el-radio-group>
          <el-form
            ref="tableFormRef"
            :model="form"
            :rules="rules"
            :show-message="false"
            class="combo-edit-table-form">
          
            <!-- 适用门店 -->
            <div v-show="activeSection === 'store'" class="combo-edit-section">
              <div class="combo-edit-table-row">
                <div class="combo-edit-table-header">
                  <div class="combo-edit-table-header_label">添加门店</div>
                  <el-select
                    v-model="storeMap.storeId"
                    placeholder="请选择门店"
                    class="combo-edit-table-header_select"
                    filterable
                    :disabled="(form.joinDept === 1) || (type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                    @change="onStoreSelect">
                    <el-option
                      v-for="item in storeMap.list"
                      :key="item.deptId"
                      :label="item.deptName"
                      :value="item.deptId">
                    </el-option>
                  </el-select>
                  <el-checkbox
                    v-model="form.joinDept"
                    class="combo-edit-table-header_checkbox"
                    :true-label="1"
                    :false-label="2"
                    :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                    @change="onJoinDeptChange">
                    全部门店
                  </el-checkbox>
                </div>
                <el-table v-show="form.joinDept === 2" :data="form.depts" border class="combo-edit-table">
                  <template slot="empty">
                    <div class="combo-edit-table-empty">请添加门店</div>
                  </template>
                  <el-table-column prop="deptCode" label="门店编号" min-width="140"></el-table-column>
                  <el-table-column prop="deptName" label="门店简称" min-width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="(type === 'add') || (type === 'edit' && [0].includes(form.status))" label="操作" width="80">
                    <template slot-scope="{ row }">
                      <el-button type="text" class="combo-edit-table-btn_delete" @click="removeStore(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 适用医生 -->
            <div v-show="activeSection === 'doctor'" class="combo-edit-section">
              <div class="combo-edit-table-row">
                <div class="combo-edit-table-header">
                  <div class="combo-edit-table-header_label">添加医生</div>
                  <el-select
                    v-model="doctorMap.doctorId"
                    placeholder="请选择医生"
                    class="combo-edit-table-header_select"
                    :disabled="(form.joinDoctor === 1) || (type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                    filterable
                    @change="onDoctorSelect">
                    <el-option
                      v-for="item in doctorMap.list"
                      :key="item.doctorId"
                      :label="item.doctorName"
                      :value="item.doctorId">
                    </el-option>
                  </el-select>
                  <el-checkbox
                    v-model="form.joinDoctor"
                    class="combo-edit-table-header_checkbox"
                    :true-label="1"
                    :false-label="2"
                    :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                    @change="onJoinDoctorChange">
                    全部医生
                  </el-checkbox>
                </div>
                <el-table v-show="form.joinDoctor === 2" :data="form.doctors" border class="combo-edit-table">
                  <template slot="empty">
                    <div class="combo-edit-table-empty">请添加医生</div>
                  </template>
                  <el-table-column prop="userCode" label="医生工号" min-width="140"></el-table-column>
                  <el-table-column prop="doctorName" label="医生姓名" min-width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="(type === 'add') || (type === 'edit' && [0].includes(form.status))" label="操作" width="80">
                    <template slot-scope="{ row }">
                      <el-button type="text" class="combo-edit-table-btn_delete" @click="removeDoctor(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 活动商品 -->
            <div v-show="activeSection === 'product'" class="combo-edit-section">
              <div class="combo-edit-table-row">
                <div class="combo-edit-table-header">
                  <div class="combo-edit-table-header_label">理疗项目</div>
                  <el-select
                    v-model="physioMap.artNo"
                    placeholder="理疗项目名称/货号"
                    class="combo-edit-table-header_select"
                    popper-class="table-select_complex-popper"
                    filterable
                    remote
                    :remote-method="remotePhysioList"
                    :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                    @change="onPhysioSelect">
                    <div class="table-select_complex-header">
                      <div class="table-select_complex-header-item select_complex_artNo">货号</div>
                      <div class="table-select_complex-header-item select_complex_name">理疗项目名称</div>
                      <div class="table-select_complex-header-item select_complex_Standard">执行模式</div>
                      <div class="table-select_complex-header-item select_complex_unit">单位</div>
                    </div>
                    <div class="table-select_complex-list">
                      <el-option v-for="item in physioMap.list" :key="item.artNo" :label="item.drugName" :value="item.artNo">
                        <div class="table-select_complex-option">
                          <div class="table-select_complex-option-item select_complex_artNo">{{ item.artNo }}</div>
                          <div class="table-select_complex-option-item select_complex_name">{{ item.drugName }}</div>
                          <div class="table-select_complex-option-item select_complex_Standard">
                            <template v-if="item.executionMode === 10">按次执行</template>
                            <template v-if="item.executionMode === 20">按组执行</template>
                          </div>
                          <div class="table-select_complex-option-item select_complex_unit">{{ item.unit }}</div>
                        </div>
                      </el-option>
                    </div>
                  </el-select>
                </div>
                <el-table :data="form.physios" border :class="{ 'combo-edit-table': true, 'combo-edit-table_all': form.cseType === 1 }" row-key="vId">
                  <template slot="empty">
                    <div class="combo-edit-table-empty">暂未添加</div>
                  </template>
                  <el-table-column prop="artNo" label="货号" min-width="80"></el-table-column>
                  <el-table-column prop="drugName" label="项目名称" min-width="160" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="executionMode" label="执行模式" min-width="210">
                    <template slot-scope="{ $index, row }">
                      <template v-if="row.executionMode === 10">
                        <div>按次执行</div>
                      </template>
                      <template v-if="row.executionMode === 20">
                        <div class="combo-edit-table-item-row">
                          <span>按组执行，每次</span>
                          <div class="combo-edit-table-form-item-group">
                            <el-form-item :prop="`physios[${$index}].groupCount`" class="combo-edit-table-form-item" required>
                              <el-input
                                v-model.trim="row.groupCount"
                                placeholder=""
                                :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                                @input="inputIntegerFormat($event, row, 'groupCount')"
                                @blur="groupCountBlur(row)">
                              </el-input>
                            </el-form-item>
                          </div>
                          <span>组</span>
                        </div>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="form.cseType === 1" label="单价" min-width="115" align="right">
                    <template slot-scope="{ $index, row }">
                      <el-form-item :prop="`physios[${$index}].price`" class="combo-edit-table-form-item" required>
                        <el-input
                          v-model.trim="row.price"
                          placeholder=""
                          :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                          @input="inputFloatFormat($event, row, 'price')"
                          @blur="tablePriceBlur(row)">
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="form.cseType === 1" label="数量" min-width="90">
                    <template slot-scope="{ $index, row }">
                      <el-form-item :prop="`physios[${$index}].quantity`" class="combo-edit-table-form-item" required>
                        <el-input
                          v-model.trim="row.quantity"
                          placeholder=""
                          :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                          @input="inputIntegerFormat($event, row, 'quantity')"
                          @blur="tableQuantityBlur(row)">
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="form.cseType === 1" label="总价" min-width="115" align="right">
                    <template slot-scope="{ $index, row }">
                      <el-form-item :prop="`physios[${$index}].totalPrice`" class="combo-edit-table-form-item" required>
                        <el-input
                          v-model="row.totalPrice"
                          placeholder=""
                          :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                          @input="inputFloatFormat($event, row, 'totalPrice')"
                          @blur="tableTotalPriceBlur(row)">
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="(type === 'add') || (type === 'edit' && [0].includes(form.status))" label="操作" width="55">
                    <template slot-scope="{ row }">
                      <el-button type="text" class="combo-edit-table-btn_delete" @click="removePhysio(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="combo-edit-table-row">
                <div class="combo-edit-table-header">
                  <div class="combo-edit-table-header_label">普通商品</div>
                  <el-select
                    v-model="drugMap.artNo"
                    placeholder="普通商品名称/货号"
                    class="combo-edit-table-header_select"
                    popper-class="table-select_complex-popper"
                    filterable
                    remote
                    :remote-method="remoteDrugList"
                    :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                    @change="onDrugSelect">
                    <div class="table-select_complex-header">
                      <div class="table-select_complex-header-item select_complex_artNo">货号</div>
                      <div class="table-select_complex-header-item select_complex_name">商品名称</div>
                      <div class="table-select_complex-header-item select_complex_Standard">规格</div>
                      <div class="table-select_complex-header-item select_complex_unit">单位</div>
                    </div>
                    <div class="table-select_complex-list">
                      <el-option v-for="item in drugMap.list" :key="item.artNo" :label="item.drugName" :value="item.artNo">
                        <div class="table-select_complex-option">
                          <div class="table-select_complex-option-item select_complex_artNo">{{ item.artNo }}</div>
                          <div class="table-select_complex-option-item select_complex_name">{{ item.drugName }}</div>
                          <div class="table-select_complex-option-item select_complex_Standard">{{ item.specifications }}</div>
                          <div class="table-select_complex-option-item select_complex_unit">{{ item.unit }}</div>
                        </div>
                      </el-option>
                    </div>
                  </el-select>
                </div>
                <el-table :data="form.drugs" border :class="{ 'combo-edit-table': true, 'combo-edit-table_all': form.cseType === 1 }" row-key="vId">
                  <template slot="empty">
                    <div class="combo-edit-table-empty">暂未添加</div>
                  </template>
                  <el-table-column prop="artNo" label="货号" min-width="80"></el-table-column>
                  <el-table-column prop="drugName" label="商品名称" min-width="160" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="specifications" label="规格" min-width="180"></el-table-column>
                  <el-table-column v-if="form.cseType === 1" label="单价" min-width="115" align="right">
                    <template slot-scope="{ $index, row }">
                      <el-form-item :prop="`drugs[${$index}].price`" class="combo-edit-table-form-item" required>
                        <el-input
                          v-model.trim="row.price"
                          placeholder=""
                          :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                          @input="inputFloatFormat($event, row, 'price')"
                          @blur="tablePriceBlur(row)">
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="form.cseType === 1" label="数量" min-width="90">
                    <template slot-scope="{ $index, row }">
                      <el-form-item :prop="`drugs[${$index}].quantity`" class="combo-edit-table-form-item" required>
                        <el-input
                          v-model.trim="row.quantity"
                          placeholder=""
                          :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                          @input="inputIntegerFormat($event, row, 'quantity')"
                          @blur="tableQuantityBlur(row)">
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="form.cseType === 1" label="总价" min-width="115" align="right">
                    <template slot-scope="{ $index, row }">
                      <el-form-item :prop="`drugs[${$index}].totalPrice`" class="combo-edit-table-form-item" required>
                        <el-input
                          v-model="row.totalPrice"
                          placeholder=""
                          :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))"
                          @input="inputFloatFormat($event, row, 'totalPrice')"
                          @blur="tableTotalPriceBlur(row)">
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="(type === 'add') || (type === 'edit' && [0].includes(form.status))" label="操作" width="55">
                    <template slot-scope="{ row }">
                      <el-button type="text" class="combo-edit-table-btn_delete" @click="removeDrug(row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 活动叠加 -->
            <div v-show="activeSection === 'overlay'" class="combo-edit-section">
              <div class="combo-edit-list-row">
                <div class="combo-edit-list-label">
                  <span class="combo-edit-list-label_required">*</span>
                  <span class="combo-edit-list-label_text">是否叠加下单送券</span>
                </div>
                <el-radio-group
                  class="combo-edit-list-radio-group"
                  v-model="form.placeOrderOverlay"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
              <div class="combo-edit-list-row">
                <div class="combo-edit-list-label">
                  <span class="combo-edit-list-label_required">*</span>
                  <span class="combo-edit-list-label_text">是否叠加优惠券</span>
                </div>
                <el-radio-group
                  class="combo-edit-list-radio-group"
                  v-model="form.couponOverlay"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
              <div class="combo-edit-list-row">
                <div class="combo-edit-list-label">
                  <span class="combo-edit-list-label_required">*</span>
                  <span class="combo-edit-list-label_text">是否叠加折扣</span>
                </div>
                <el-radio-group
                  class="combo-edit-list-radio-group"
                  v-model="form.discountOverlay"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
              <div class="combo-edit-list-row">
                <div class="combo-edit-list-label">
                  <span class="combo-edit-list-label_required">*</span>
                  <span class="combo-edit-list-label_text">是否叠加满赠</span>
                </div>
                <el-radio-group
                  class="combo-edit-list-radio-group"
                  v-model="form.freeGiftPurchaseOverlay"
                  :disabled="(type === 'view') || (type === 'edit' && [1, 2].includes(form.status))">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" v-if="['-1', '0'].includes(deptId) && (type === 'view' && [0, 1].includes(form.status))" @click="toEdit">修改</el-button>
        <el-button type="primary" v-if="['-1', '0'].includes(deptId) && ((type === 'add') || (type === 'edit' && [0, 1].includes(form.status)))" :loading="loading" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getComboDeptList, getComboDoctorList, getComboDrugList, getComboSaleInfo, postComboSale } from '@/api/campaign'
export default {
  name: 'ComboEdit',
  data() {
    return {
      deptId: sessionStorage.getItem('deptId') || '',
      visible: false,
      loading: false,
      type: 'add', // add: 新增, view: 查看, edit: 修改
      activeSection: 'store',
      sectionTabs: [
        { label: '适用门店', value: 'store' },
        { label: '适用医生', value: 'doctor' },
        { label: '活动商品', value: 'product' },
        { label: '活动叠加', value: 'overlay' }
      ],
      storeMap: {
        storeId: '',
        list: []
      },
      doctorMap: {
        doctorId: '',
        list: []
      },
      physioMap: {
        artNo: '',
        list: []
      },
      drugMap: {
        artNo: '',
        list: []
      },
      rules: {
        cseName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }, { validator: this.validateStartTime, trigger: 'change' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }, { validator: this.validateEndTime, trigger: 'change' }],
        cseType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
        drugCount: [{ required: true, message: '请输入件数', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        labels: [{ required: true, message: '请选择活动标签', trigger: 'change' }]
      },
      form: {
        cseCode: '',
        status: '',
        cseName: '',
        startTime: '',
        endTime: '',
        cseType: 2,
        drugCount: '',
        price: '',
        labels: [],

        joinDept: 2,
        depts: [],

        joinDoctor: 2,
        doctors: [],

        physios: [],
        drugs: [],

        placeOrderOverlay: '',
        couponOverlay: '',
        discountOverlay: '',
        freeGiftPurchaseOverlay: ''
      }
    }
  },
  computed: {
    title() {
      const typeMap = {
        'view': '查看',
        'edit': '修改',
        'add': '新增'
      }
      return typeMap[this.type] || ''
    },
    startTimePickerOptions() {
      return {
        disabledDate: (time) => {
          const todayStart = this.getTodayStartTime()
          if (time.getTime() < todayStart) return true
          if (this.form.endTime) {
            return time.getTime() > new Date(this.form.endTime).getTime()
          }
          return false
        }
      }
    },
    endTimePickerOptions() {
      return {
        disabledDate: (time) => {
          const minTime = this.form.startTime ? new Date(this.form.startTime).getTime() : this.getTodayStartTime()
          return time.getTime() < minTime
        }
      }
    },
    comboQuantityCount () {
      let num = 0
      this.form.physios.forEach(item => {
        num += Number(item.quantity || 0)
      })
      this.form.drugs.forEach(item => {
        num += Number(item.quantity || 0)
      })
      return Math.round(num * 100) / 100 || '-'
    },
    comboTotalPriceCount () {
      let price = 0
      this.form.physios.forEach(item => {
        price += Number(item.totalPrice || 0)
      })
      this.form.drugs.forEach(item => {
        price += Number(item.totalPrice || 0)
      })
      return Math.round(price * 100) / 100 || '-'
    }
  },
  methods: {
    generateUUID () {
      return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    getTodayStartTime() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today.getTime()
    },
    validateStartTime(rule, value, callback) {
      if (!value) return callback()
      const startTime = new Date(value).getTime()
      const todayStart = this.getTodayStartTime()
      if (this.type === 'add' && startTime < todayStart) {
        return callback(new Error('开始时间不能早于今天'))
      }
      if (this.form.endTime && startTime > new Date(this.form.endTime).getTime()) {
        return callback(new Error('开始时间不能大于结束时间'))
      }
      callback()
    },
    validateEndTime(rule, value, callback) {
      if (!value) return callback()
      if (this.form.startTime && new Date(value).getTime() < new Date(this.form.startTime).getTime()) {
        return callback(new Error('结束时间不能早于开始时间'))
      }
      callback()
    },
    handleStartTimeChange(value) {
      if (!value) return
      const startTime = new Date(value).getTime()
      const todayStart = this.getTodayStartTime()
      if (startTime < todayStart) {
        this.form.startTime = ''
        this.$message.error('开始时间不能早于今天')
        return
      }
      if (this.form.endTime && startTime > new Date(this.form.endTime).getTime()) {
        this.form.endTime = ''
      }
    },
    handleEndTimeChange(value) {
      if (!value) return
      if (this.form.startTime && new Date(value).getTime() < new Date(this.form.startTime).getTime()) {
        this.form.endTime = ''
        this.$message.error('结束时间不能早于开始时间')
      }
    },
    handleDrugCountInput(value) {
      this.form.drugCount = String(value || '').replace(/[^\d]/g, '')
    },
    handlePriceInput(value) {
      const input = String(value || '').replace(/[^\d.]/g, '')
      const match = input.match(/^\d*(?:\.\d{0,2})?/)
      this.form.price = match ? match[0] : ''
    },
    onCseTypeChange () {
      this.form.drugCount = ''
      this.form.price = ''
      if (this.form.physios.length > 0 || this.form.drugs.length > 0) {
        this.form.physios = []
        this.form.drugs = []
        this.$message.warning('活动类型切换后，请重新添加活动商品')
      }
    },
    inputIntegerFormat (value, row, key) {
      row[key] = String(value || '').replace(/[^\d]/g, '')
    },
    inputFloatFormat(value, row, key) {
      const input = String(value || '').replace(/[^\d.]/g, '')
      const match = input.match(/^\d*(?:\.\d{0,2})?/)
      row[key] = match ? match[0] : ''
    },
    // 获取适用门店列表
    async getStoreList() {
      const res = await getComboDeptList({
        pageNo: 1,
        pageSize: 1000
      })
      if (res.code === 200) {
        this.storeMap.list = res.data && res.data.list || []
      }
    },
    // 获取适用医生列表
    async getDoctorList() {
      const res = await getComboDoctorList({
        pageNo: 1,
        pageSize: 9999
      })
      if (res.code === 200) {
        this.doctorMap.list = res.data && res.data.list || []
      }
    },
    // 获取活动详情
    async getComboInfo() {
      const res = await getComboSaleInfo({ cseCode: this.form.cseCode })
      if (res.code === 200 && res.data) {
        Object.keys(this.form).forEach(key => {
          if (res.data.hasOwnProperty(key)) {
            if (['physios', 'drugs'].includes(key)) {
              res.data[key].map(item => {
                item['vId'] = this.generateUUID()
                item['price'] = Math.round(Number(item.totalPrice) / Number(item.quantity) * 100) / 100
              })
            }
            this.form[key] = res.data[key]
          }
        })
      }
    },
    open(type = 'add', code = '') {
      this.type = type
      this.form.cseCode = code
      this.visible = true
      this.getStoreList()
      this.getDoctorList()
      if (['view', 'edit'].includes(type)) {
        this.getComboInfo()
      }
    },
    close() {
      this.visible = false

      this.activeSection = 'store'

      this.form = {
        cseCode: '',
        status: '',
        cseName: '',
        startTime: '',
        endTime: '',
        cseType: 2,
        drugCount: '',
        price: '',
        labels: [],

        joinDept: 2,
        depts: [],

        joinDoctor: 2,
        doctors: [],

        physios: [],
        drugs: [],

        placeOrderOverlay: '',
        couponOverlay: '',
        discountOverlay: '',
        freeGiftPurchaseOverlay: ''
      }
      this.$nextTick(() => {
        this.$refs['formRef'].clearValidate()
      })
    },
    onJoinDeptChange () {
      this.form.depts = []
    },
    onStoreSelect () {
      if (this.storeMap.storeId) {
        const store = this.storeMap.list.find(item => item.deptId === this.storeMap.storeId)
        if (store) {
          const hasStatus = this.form.depts.some(item => item.deptId === store.deptId)
          if (!hasStatus) {
            this.form.depts.push(JSON.parse(JSON.stringify(store)))
          } else {
            this.$message.error('该门店已添加')
          }
        }
        this.$nextTick(() => {
          this.storeMap.storeId = ''
        })
      }
    },
    removeStore(row) {
      this.form.depts = this.form.depts.filter(item => item.deptId !== row.deptId)
    },
    onJoinDoctorChange () {
      this.form.doctors = []
    },
    onDoctorSelect () {
      if (this.doctorMap.doctorId) {
        const doctor = this.doctorMap.list.find(item => item.doctorId === this.doctorMap.doctorId)
        if (doctor) {
          const hasStatus = this.form.doctors.some(item => item.doctorId === doctor.doctorId)
          if (!hasStatus) {
            this.form.doctors.push(JSON.parse(JSON.stringify(doctor)))
          }else {
            this.$message.error('该医生已添加')
          }
        } 
        this.$nextTick(() => {
          this.doctorMap.doctorId = ''
        })
      }
    },
    removeDoctor(row) {
      this.form.doctors = this.form.doctors.filter(item => item.doctorId !== row.doctorId)
    },
    async remotePhysioList (query) {
      if (query) {
        const res = await getComboDrugList({
          seachPhysio: 2,
          keyword: query,
          pageNo: 1,
          pageSize: 100
        })
        if (res.code === 200) {
          this.physioMap.list = res.data && res.data.list || []
        }
      } else {
        this.physioMap.list = []
      }
    },
    onPhysioSelect () {
      if (this.physioMap.artNo) {
        const physio = this.physioMap.list.find(item => item.artNo === this.physioMap.artNo)
        if (physio) {
          const hasStatus = this.form.physios.some(item => item.artNo === physio.artNo)
          if (hasStatus) {
            this.$message.error('该理疗项目已添加')
            return
          }
          const newPhysio = JSON.parse(JSON.stringify(physio))
          newPhysio['vId'] = this.generateUUID()
          newPhysio['groupCount'] = ''
          newPhysio['price'] = ''
          newPhysio['quantity'] = 1
          newPhysio['totalPrice'] = ''
          this.form.physios.push(newPhysio)
        }
        this.$nextTick(() => {
          this.physioMap.artNo = ''
          this.physioMap.list = []
        })
      }
    },
    removePhysio (row) {
      this.form.physios = this.form.physios.filter(item => item.vId !== row.vId)
    },
    groupCountBlur (row) {
      if (row.groupCount && ![0, '0'].includes(row.groupCount)) {
        row.groupCount = Number(row.groupCount)
      } else {
        row.groupCount = ''
      }
    },
    tablePriceBlur (row) {
      if (row.price && ![0, '0'].includes(row.price)) {
        row.price = Number(row.price)
        if (![null, undefined, '', '0', 0].includes(row.quantity)) {
          row.totalPrice = Math.round(row.price * row.quantity * 100) / 100
        }
      } else {
        row.price = ''
      }
    },
    tableQuantityBlur (row) {
      if (row.quantity && ![0, '0'].includes(row.quantity)) {
        row.quantity = Number(row.quantity)
        if (![null, undefined, '', '0', 0].includes(row.price)) {
          row.totalPrice = Math.round(row.price * row.quantity * 100) / 100
        }
      } else {
        row.quantity = ''
      }
    },
    tableTotalPriceBlur (row) {
      if (row.totalPrice && ![0, '0'].includes(row.totalPrice)) {
        row.totalPrice = Number(row.totalPrice)
        if (![null, undefined, '', '0', 0].includes(row.quantity)) {
          row.price = Math.round(row.totalPrice / row.quantity * 100) / 100
        }
      } else {
        row.totalPrice = ''
      }
    },
    async remoteDrugList (query) {
      if (query) {
        const res = await getComboDrugList({
          seachPhysio: 1,
          keyword: query,
          pageNo: 1,
          pageSize: 100
        })
        if (res.code === 200) {
          this.drugMap.list = res.data && res.data.list || []
        }
      } else {
        this.drugMap.list = []
      }
    },
    onDrugSelect () {
      if (this.drugMap.artNo) {
        const drug = this.drugMap.list.find(item => item.artNo === this.drugMap.artNo)
        if (drug) {
          if (this.form.cseType === 2) {
            const hasStatus = this.form.drugs.some(item => item.artNo === drug.artNo)
            if (hasStatus) {
              this.$message.error('该商品已添加')
              return
            }
          }
          const newDrug = JSON.parse(JSON.stringify(drug))
          newDrug['vId'] = this.generateUUID()
          newDrug['groupCount'] = ''
          newDrug['price'] = ''
          newDrug['quantity'] = 1
          newDrug['totalPrice'] = ''
          this.form.drugs.push(newDrug)
        }
        this.$nextTick(() => {
          this.drugMap.artNo = ''
          this.drugMap.list = []
        })
      }
    },
    removeDrug (row) {
      this.form.drugs = this.form.drugs.filter(item => item.vId !== row.vId)
    },
    toEdit () {
      this.type = 'edit'
    },
    async validate() {
      try {
        const formRefValid = await new Promise(resolve => {
          this.$refs['formRef'].validate(valid => {
            resolve(valid)
          })
        })
        if (!formRefValid) return false

        if (this.form.joinDept === 2 && this.form.depts.length === 0) {
          this.$message.error('请选择适用门店')
          return false
        }
        if (this.form.joinDoctor === 2 && this.form.doctors.length === 0) {
          this.$message.error('请选择适用医生')
          return false
        }
        if (this.form.physios.length === 0 && this.form.drugs.length === 0) {
          this.$message.error('请选择活动商品')
          return false
        }
        const rules = ['placeOrderOverlay', 'couponOverlay', 'discountOverlay', 'freeGiftPurchaseOverlay']
        if (rules.some(item => ['', null, undefined].includes(this.form[item]))) {
          this.$message.error('请完善活动叠加规则')
          return false
        }

        const tableFormRefValid = await new Promise(resolve => {
          this.$refs['tableFormRef'].validate(valid => {
            resolve(valid)
          })
        })
        if (!tableFormRefValid) {
          this.$message.error('请完善活动商品信息')
        }
        return tableFormRefValid
      } catch (error) {
        return false
      }
    },
    async confirm() {
      const valid = await this.validate()
      if (valid) {
        this.loading = true
        const res = await postComboSale(this.form)
        this.loading = false
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.close()
          this.$emit('success')
        }
      }
    }
  }
}
</script>

<style lang="less">
  .table-select_complex-popper .el-select-dropdown__list {
    padding: 0;
  }
</style>
<style lang="less" scoped>
  .comboEdit-dialog /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .comboEdit-dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .comboEdit-dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    font-size: 18px;
  }

  .comboEdit-dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .comboEdit-dialog /deep/ .el-dialog__footer {
    padding: 12px 16px;
    border-top: 1px solid #E0E0E0;
  }

  .content {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    max-height: 600px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }

  .combo-edit-form /deep/ .el-form-item {
    margin-bottom: 18px;
  }

  .combo-edit-form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #667182;
  }

  .combo-edit-form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .combo-edit-field {
    width: 400px;
  }

  .combo-edit-date-form-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .combo-edit-date-form-text {
    margin: 0 8px;
    font-size: 14px;
    color: #606266;
  }

  .combo-edit-date-form-item {
    margin: 0 0 0 0 !important;
  }

  .combo-edit-daterange {
    width: 200px;
  }

  .combo-edit-daterange /deep/ .el-range__close-icon {
    line-height: 25px;
  }

  .combo-edit-radio-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32px;
  }

  .combo-edit-radio-group /deep/ .el-radio {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 0;
  }

  .combo-edit-radio-group /deep/ .el-radio + .el-radio {
    margin: 0 0 0 24px;
  }

  .combo-edit-radio-group /deep/ .el-radio__label {
    padding: 0 0 0 4px;
  }

  .combo-edit-radio-group /deep/ .el-radio__input {
    height: 14px;
  }

  .combo-edit-checkbox-group /deep/ .el-checkbox {
    margin: 0 0 0 0;
  }

  .combo-edit-checkbox-group /deep/ .el-checkbox + .el-checkbox {
    margin: 0 0 0 24px;
  }

  .combo-edit-checkbox-group /deep/ .el-checkbox__label {
    padding: 0 0 0 4px;
  }

  .combo-edit-checkbox-group /deep/ .el-form-item__error {
    top: calc(100% - 10px);
  }

  .combo-edit-rule-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32px;
  }

  .combo-edit-rule-form-item {
    margin: 0 12px !important;
    width: 96px;
  }

  .combo-edit-rule-optional_text {
    font-size: 14px;
    color: #667182;
  }

  .combo-edit-rule-combo-count {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  
  .combo-edit-rule-combo-count_text {
    line-height: 24px;
    font-size: 14px;
    color: #667182;
  }

  .combo-edit-rule-combo-count_num {
    line-height: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .combo-edit-rule-combo-tips {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 16px;
  }

  .combo-edit-rule-combo-tips_icon {
    font-size: 16px;
    color: #1890FF;
  }

  .combo-edit-rule-combo-tips_text {
    margin: 0 0 0 2px;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .combo-edit-tabs {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .combo-edit-tabs /deep/ .el-radio-button__inner {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 36px;
    color: #000000;
  }

  .combo-edit-tabs /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFFFFF;
  }

  .combo-edit-section {
    width: 100%;
    overflow: hidden;
  }

  .combo-edit-table-row {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .combo-edit-table-row + .combo-edit-table-row {
    margin: 24px 0 0 0;
  }

  .combo-edit-table-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .combo-edit-table-header_label {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .combo-edit-table-header_select {
    margin: 0 0 0 16px;
    width: 220px;
  }

  .combo-edit-table-header_checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 16px;
  }

  .combo-edit-table-header_checkbox /deep/ .el-checkbox__input {
    height: 14px;
  }

  .combo-edit-table-header_checkbox /deep/ .el-checkbox__label {
    padding: 0 0 0 4px;
  }

  .combo-edit-table {
    margin: 16px 0 0 0;
    width: 550px;
  }

  .combo-edit-table.combo-edit-table_all {
    width: 100%;
  }

  .combo-edit-table-empty {
    line-height: 20px;
    font-size: 14px;
    color: #A4AFBA;
  }

  .combo-edit-table-btn_delete {
    font-size: 14px;
    color: #F54A45;
  }

  .combo-edit-list-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .combo-edit-list-label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 120px;
  }

  .combo-edit-list-label_required {
    font-size: 14px;
    color: #F54A45;
  }

  .combo-edit-list-label_text {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .combo-edit-list-radio-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 16px;
  }

  .combo-edit-list-radio-group /deep/ .el-radio {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 0;
  }

  .combo-edit-list-radio-group /deep/ .el-radio + .el-radio {
    margin: 0 0 0 24px;
  }

  .combo-edit-list-radio-group /deep/ .el-radio__input {
    height: 14px;
  }

  .table-select_complex-header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .table-select_complex-header-item {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    color: #667182;
    background-color: #F0F1F3;
  }

  .table-select_complex-list {
    width: 100%;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .table-select_complex-list /deep/ .el-select-dropdown__item {
    padding: 0;
    height: 36px;
    line-height: 36px;
  }

  .table-select_complex-option {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .table-select_complex-option-item {
    box-sizing: border-box;
    padding: 0 12px;
    height: 36px;
    line-height: 36px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    background-color: #FFFFFF;
  }

  .table-select_complex-list /deep/ .hover .table-select_complex-option-item {
    color: #1890FF;
    background-color: #E8F4FF;
  }

  .select_complex_artNo {
    width: 100px;
  }

  .select_complex_name {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .select_complex_Standard {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .select_complex_unit {
    width: 80px;
  }

  .combo-edit-table-form-item {
    margin: 0 0 0 0;
  }

  .combo-edit-table-form-item /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .combo-edit-table-item-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .combo-edit-table-form-item-group {
    margin: 0 4px;
    width: 50px;
  }
</style>
